import type { SubjectDto } from './api/access-control.client'

export * from './constants/assignable-roles'

// "Manage" is the owner action: granting it covers every other action on a
// menu. It maps to CASL's `manage` wildcard on the backend. It is the ONE
// hardcoded action — its "covers everything" behavior is UI/CASL logic, not
// catalog data — so the backend omits it from the fetched catalog and the UI
// layers it onto every subject here.
export const MANAGE_ACTION = 'Manage'

export const READ_ACTION = 'Read'

// The subject (seeded in the RBAC migration) that governs access to this very
// screen. `Read` on it grants view-only access; `Manage` lets a role
// administer roles/permissions.
export const PERMISSION_MANAGEMENT_SUBJECT = 'PermissionManagement'

// The subject (menu) catalog is fetched from the DB (see useSubjectsQuery).
// These helpers derive per-menu action lists from that fetched catalog.

// Selectable actions for a menu, EXCLUDING Manage — the actions the catalog
// stores. Used by the user drawer (Manage is role-level only there).
export function directActionsFor(
  subjects: SubjectDto[],
  menu: string
): string[] {
  return subjects.find((s) => s.subjectId === menu)?.actions ?? []
}

// Every action for a menu INCLUDING Manage (first, so it renders as the leading
// pill per the design). Used by the role permissions editor.
export function allActionsFor(subjects: SubjectDto[], menu: string): string[] {
  return [MANAGE_ACTION, ...directActionsFor(subjects, menu)]
}

// "AdminPortal" -> "Admin Portal", "TestMode" -> "Test Mode"
export function formatLabel(value: string): string {
  return value.replace(/([a-z])([A-Z])/g, '$1 $2')
}
